const carrierMotiveConnectionFormConfig = () => {
	return {
		urlGET: "api/profile/carriers/:carrierId/details/configuration",
		urlPUT: "api/profile/carriers/:carrierId/motive/key",
		urlDELETE: "api/profile/carriers/:carrierId/motive/key",
		idKey: "_id",
		triggerEvent: ["profileRevision"],
		listenEvent: ["profileRevision"],
		header: {
			create: { label: "Add Motive API Key Configuration" },
			edit: { label: "Edit Motive API Key Configuration" },
		},
		messages: {
			edit: { success: "Motive API key updated successfully" },
			create: { sameAs: "edit" },
			delete: { success: "Motive connection removed successfully" },
		},
		content: {
			view: {
				items: [
					{
						key: "information_message",
						type: "message",
						builder: () =>
							`Motive integration enables automatic synchronization of vehicles, drivers, and real-time tracking data with your SmartHop account.`,
					},
					{
						type: "group",
						content: {
							items: [
								{
									key: "Status",
									type: "text",
									label: "Status",
									builder: (item) => {
										if (item?.motiveConnection?.access_token) {
											return "Connected (OAuth)";
										} else if (item?.motiveConnection?.api_key) {
											return "Connected (API Key)";
										}
										return "Not Configured";
									},
								},
								{
									key: "connection_type",
									hidden: (item) => !item?.motiveConnection?.api_key && !item?.motiveConnection?.access_token,
									type: "text",
									label: "Connection Type",
									builder: (item) => {
										if (item?.motiveConnection?.access_token) {
											return "OAuth 2.0 Flow";
										} else if (item?.motiveConnection?.api_key) {
											return "API Key";
										}
										return "Not Connected";
									},
								},
							],
						},
					},
					{
						type: "group",
						content: {
							items: [
								{
									key: "organization_id",
									hidden: (item) => !item?.motiveConnection?.organization_id,
									type: "text",
									label: "Organization ID",
									builder: (item) => item?.motiveConnection?.organization_id,
								},
								{
									key: "api_user_id",
									hidden: (item) => !item?.motiveConnection?.api_user_id,
									type: "text",
									label: "API User ID",
									builder: (item) => item?.motiveConnection?.api_user_id,
								},
								{
									key: "dot_ids",
									hidden: (item) => !item?.motiveConnection?.dot_ids || item?.motiveConnection?.dot_ids?.length === 0,
									type: "text",
									label: "DOT IDs",
									builder: (item) => item?.motiveConnection?.dot_ids?.join(", "),
								},
							],
						},
					},
					{
						type: "group",
						content: {
							items: [
								{
									key: "vehicleCount",
									hidden: (item) => !item?.motiveConnection?.vehicleCount && item?.motiveConnection?.vehicleCount !== 0,
									type: "number",
									label: "Vehicle Count",
									builder: (item) => item?.motiveConnection?.vehicleCount,
								},
								{
									key: "driverCount",
									hidden: (item) => !item?.motiveConnection?.driverCount && item?.motiveConnection?.driverCount !== 0,
									type: "number",
									label: "Driver Count",
									builder: (item) => item?.motiveConnection?.driverCount,
								},
							],
						},
					},
					{
						type: "group",
						content: {
							items: [
								{
									key: "connected_at",
									hidden: (item) => !item?.motiveConnection?.connected_at,
									type: "text",
									label: "Connected At",
									builder: (item) => {
										if (item?.motiveConnection?.connected_at) {
											return new Date(item.motiveConnection.connected_at).toLocaleDateString();
										}
										return "";
									},
								},
								{
									key: "expires_at",
									hidden: (item) => !item?.motiveConnection?.expires_at,
									type: "text",
									label: "Token Expires At",
									builder: (item) => {
										if (item?.motiveConnection?.expires_at) {
											return new Date(item.motiveConnection.expires_at).toLocaleDateString();
										}
										return "";
									},
								},
							],
						},
					},
				],
			},
			create: {
				sameAs: "edit",
			},
			edit: {
				items: [
					{
						key: "information_message",
						type: "message",
						builder: () =>
							`Configure your Motive API key to enable automatic synchronization of vehicles, drivers, and tracking data. This will allow SmartHop to integrate with your Motive fleet management system.`,
					},
					{
						type: "group",
						label: "API Key Configuration",
						content: {
							items: [
								{
									key: "api_key",
									type: "text",
									label: "API Key",
									placeholder: "Enter Motive API Key",
									validation: { required: true },
									defaultValue: (item) => item?.motiveConnection?.api_key || "",
									description: "Your Motive API key. This can be found in your Motive dashboard under Settings > API.",
								},
								{
									key: "api_user_id",
									type: "text",
									label: "API User ID (Optional)",
									placeholder: "Enter API User ID",
									defaultValue: (item) => item?.motiveConnection?.api_user_id || "",
									description: "Optional user ID for additional API permissions and tracking.",
								},
							],
						},
					},
					{
						type: "group",
						content: {
							items: [
								{
									type: "action",
									action: "SUBMIT",
									label: "Save",
								},
								{
									type: "action",
									action: "DELETE",
									label: "Remove Connection",
									hidden: (item) => !item?.motiveConnection?.api_key && !item?.motiveConnection?.access_token,
									confirmation: {
										title: "Remove Motive Connection",
										message:
											"Are you sure you want to remove the Motive connection? This will stop all tracking and data synchronization.",
										confirmText: "Remove",
										cancelText: "Cancel",
									},
								},
							],
						},
					},
				],
			},
		},
	};
};

export default carrierMotiveConnectionFormConfig;
